import React from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import BSL_Dialog from "../components/BSL_Dialog";
import { LinearProgress } from "@material-ui/core";
import { fetchTimeout } from "../components/Common";
import { Palette, API_BASE } from "../AppConfig";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ManageProductListItem from "./ManageProductListItem";

const useStyles = makeStyles((theme) => ({
    root: {
        flex: 1,
        maxWidth: "90%",
        minWidth: "600px",
    },
    container: {
        height: "90%",
        maxHeight: "calc(100% - 65px)",
    },
    row: {
        "tr:hover": {
            backgroundColor: "rgb(7, 50, 50, 0.42)",
        },
    },
    rowCell: {
        fontSize: "12px",
        border: "none",
        padding: "2px 0px 2px 24px",
        color: theme.brand.FIELDERS ? "inherit" : Palette.Lysaght.MidGrey,
        "&:hover": {
            backgroundColor: "rgb(7, 177, 77, 0.42)",
            cursor: "pointer",
        },
    },
    headingCell: {
        fontSize: "11px",
        border: "none",
        padding: "2px 0px 2px 24px",
        textTransform: "uppercase",
        color: "#ffffff",
        fontWeight: theme.brand.FIELDERS ? "inherit" : "600",
        fontFamily: theme.typography.fontFamilySecondary,
        backgroundColor: Palette.FieldersBlue,
        lineHeight: "normal",
    },
    no_job_message: {
        color: "grey",
        height: "100px",
        fontSize: "20px",
        fontStyle: "italic",
        paddingTop: "40px",
        position: "absolute",
        left: "47%",
        top: "58px",
    },
}));

const columns = [
    {
        id: "datetime",
        label: "Date Time",
    },
    {
        id: "user",
        label: "User",
    },
    {
        id: "action",
        label: "Action",
    },
    {
        id: "row_data",
        label: "Data",
    },
];

export default function ManageProductListItemHistory(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { row, config } = props;
    const [intialise, setIntialise] = React.useState(false);
    const [history, setHistory] = React.useState([]);
    const [viewItem, setViewItem] = React.useState(false);

    React.useEffect(() => {
        if (!intialise) {
            let api_url = API_BASE() + "admin/GetPriceFileDataHistory?id=" + row.id;
            fetchTimeout(api_url, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((json) => {
                    let data = [...json];
                    data.sort((a, b) => {
                        return a.timestamp < b.timestamp ? 1 : -1;
                    });

                    setHistory(data);

                    setIntialise(true);
                })
                .catch((e) => {
                    
                    setIntialise(true);
                });
        }
    }, [intialise]);

    let row_i = 0;

    return (
        <BSL_Dialog
            title={"History for " + row?.["ProductIndex"] + " - " + row?.["ProductDescription"]}
            open={true}
            onClose={() => {
                props.onClose();
            }}
            button2Text="Cancel"
            button2Click={() => {
                props.onClose();
            }}
            style={{ maxWidth: "initial" }}
            fullWidth={true}
            maxWidth={"md"}
        >
            {!intialise && <LinearProgress />}
            <TableContainer className={classes.container}>
                <Table stickyHeader size="small" aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) =>
                                column?.hideInTable ? null : (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                        className={classes.headingCell}
                                    >
                                        {column.label}
                                    </TableCell>
                                )
                            )}
                            <TableCell key={"Options"} className={classes.headingCell}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {history &&
                            history.map((item) => {
                                row_i++;
                                return (
                                    <TableRow
                                        key={item.timestamp}
                                        hover
                                        role="checkbox"
                                        tabIndex={-1}
                                        className={classes.row}
                                        style={{ background: row_i % 2 === 0 ? "#e7ebee" : "#ffffff" }}
                                    >
                                        <TableCell key={item.timestamp + "-datetime"}>{item["datetime"]}</TableCell>
                                        <TableCell key={item.timestamp + "-user"}>{item["user"]}</TableCell>
                                        <TableCell key={item.timestamp + "-action"}>
                                            {item?.["action"] ? item?.["action"].replaceAll("_", " ") : ""}
                                        </TableCell>
                                        <TableCell key={item.timestamp + "-data"}>
                                            <div className="link" onClick={() => setViewItem(item["row_data"])}>
                                                view data
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                    {(!history || history.length === 0) && (
                        <div className={classes.no_job_message}>{"No History ..."}</div>
                    )}
                </Table>
            </TableContainer>

            {viewItem && (
                <ManageProductListItem
                    action={"VIEW"}
                    row={viewItem}
                    columns={props.columns}
                    onClose={() => {
                        setViewItem(false);
                    }}
                    config={props.config}
                    saveValue={(row, param) => {
                        setViewItem(false);
                    }}
                />
            )}
        </BSL_Dialog>
    );
}
